module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-image-1-533x800-52e113aaaae195185b666c2590bff7e1.jpg";